// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NNcn","colBig":"styles_colBig__2Ndoq","colSmall":"styles_colSmall__1eDTR","shopifyNameWrapper":"styles_shopifyNameWrapper__1AATy"};